import {useSuspenseQuery} from "@apollo/client";
import {useFormContext} from "react-hook-form";
import {useParams} from "react-router";

import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {MultiServiceSelect} from "@/components/multiServiceSelect/MultiServiceSelect.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {GetServiceTypesAndTagsResult, GQL_GET_SERVICE_TYPES_AND_TAGS} from "@/lib/queries/statuspages.ts";
import {MaintenanceScheduleFormData} from "@/pages/maintenance/maintenance-create/CreateEditMaintenanceScheduleForm.types.ts";

export const MaintenanceScheduleAffectedChecksTab = () => {
  const {id} = useParams<{id: string}>();
  const currentScheduleId = id ? parseInt(id, 10) : undefined;
  const {
    watch,
    setValue,
    formState: {errors},
  } = useFormContext<MaintenanceScheduleFormData>();
  const affectedChecksError = getFormError("affected_checks", errors);
  const {data} = useSuspenseQuery<GetServiceTypesAndTagsResult>(GQL_GET_SERVICE_TYPES_AND_TAGS);
  const {monitoringServiceTypes, tags} = data;

  return (
    <div>
      <MultiServiceSelect
        defaultValue={watch("affected_checks").map((check) => check.id)}
        onAppend={(id) => {
          setValue("affected_checks", [{id}, ...watch("affected_checks")], {shouldDirty: true});
        }}
        onReplace={(ids) => {
          setValue(
            "affected_checks",
            ids.map((id) => ({id})),
            {shouldDirty: true}
          );
        }}
        monitoringServiceTypes={monitoringServiceTypes}
        tags={tags}
        scheduleConfig={{showLinkedSchedules: true, currentScheduleId}}
        serviceLimit={null}
      />
      <FormSubtext error={affectedChecksError?.toString()} />
    </div>
  );
};
